import Grid from "@mui/material/Grid";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useState } from "react";
import dayjs, { Dayjs } from "dayjs";

interface DateRangePickerProps {
    initialStartDate: Date;
    initialEndDate: Date;
    onDateChange: (start: Date | null, end: Date | null) => void;
}

const DateRangeInput: React.FC<DateRangePickerProps> = ({ initialStartDate, initialEndDate, onDateChange }) => {
    const [startDate, setStartDate] = useState<Date | null>(initialStartDate);
    const [endDate, setEndDate] = useState<Date | null>(initialEndDate);

    const handleFromDateChange = (date: Dayjs | null) => {
        if (dayjs(date).isValid()) {
            setStartDate(date?.toDate() ?? null);
            onDateChange(date?.toDate() ?? null, endDate)
        }
    };

    const handleToDateChange = (date: Dayjs | null) => {
        if (dayjs(date).isValid()) {
            setEndDate(date?.toDate() ?? null);
            onDateChange(startDate, date?.toDate() ?? null)
        }
    };

    return (
        <Grid container>
            <Grid
                sx={{ padding: '4px', width: "50%", marginTop: "8px" }}
            >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        label="From"
                        className="w-100 bg-white"
                        format="YYYY/MM/DD"
                        value={dayjs(initialStartDate)}
                        maxDate={dayjs(initialEndDate)}
                        onChange={handleFromDateChange}
                    />
                </LocalizationProvider>
            </Grid>
            <Grid
                sx={{ padding: '4px', width: "50%", marginTop: "8px" }}
            >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        label="To"
                        className="w-100 bg-white"
                        format="YYYY/MM/DD"
                        value={dayjs(initialEndDate)}
                        minDate={dayjs(initialStartDate)}
                        onChange={handleToDateChange}
                    />
                </LocalizationProvider>
            </Grid>
        </Grid>
    );
}

export default DateRangeInput;


